import React, { useState, useEffect, useContext, useCallback, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { DI, DIProps } from '../../Core';
import { appBridgeRouting, checkForAutoLogin, isAdminLoggedIn, openAppInEmbedded, redirectToApp, RedirectToHome, RenderSkeleton, ShowLogOutScreen, showOnlyGrid } from './Panel/index';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';
import { syncNecessaryInfo, syncConnectorInfo, syncProfileInfo, loginStatus, syncServices, saveCurrentPlanData } from '../../Actions';
import { StoreDispatcher } from '../..';
import Onboarding from './Onboarding/components/Onboarding';
import { Button, Card, Frame, Navigation, Page, Select, FooterHelp, Icon, Popover, ActionList, BlockStack, Text, InlineStack, Link, Modal, Banner, PopoverCloseSource, Image, List, Badge, Checkbox, Box } from '@shopify/polaris';
import Settings from './Settings/components/Settings';
import Editproduct from './Editproduct/Editproduct';
import EditproductNew from './EditproductNew/Editproduct';
import { MenuObj, Menu } from './Panel/Menu';
import { AddMajor, CircleInformationMajor } from '@shopify/polaris-icons';
import FailedOrder from './FailedOrder/components/FailedOrder';
import ViewOrder from './FailedOrder/components/ViewOrder';
import ArchivedOrder from './FailedOrder/components/ArchivedOrder';
import NewAccount from './Onboarding/components/NewAccount';
import Activity from './Activity/Component/Activity';
import EditVariant from './EditVariant/components/EditVariant';
import EditVariantNew from './EditVariantNew/components/EditVariant';
import Feeds from './Feeds/components/Feeds';
import TransferOrder from './TransferOrder/components/TransferOrder';
import { aAppdef } from '../../App';
import { getCountryFlag, hasSelectedLanguage } from '.';
import CancelledOrders from './CancelOrders/components/CancelOrders';
import Support from './Support/components/Support';
import UnshippedOrders from './UnshippedOrders/components/UnshippedOrders';
import AllSales from './AllSales/components/AllSales';
import { isMobile, isShopifyEmbedded } from '@shopify/app-bridge/utilities';
import ValueMapping from './NewValueMapping/Components/ValueMapping';
import NewPricingPlan from './Pricing/NewPricingPlan';
import BFCM2024 from './Pricing/BFCM2024';
import SettlementModal from './Pricing/PricingModal/components/SettlementModal';
import '../../styles.css';
// import ViewAllStores from './LocalSelling/Componants/ViewAllStores';
// import Order from './LocalSelling/Componants/OrderGrid/Order';
// import CreateStoreForm from './LocalSelling/Componants/Store Grid/CreateStore/CreateStoreForm';
import NewConfig from './Config/NewConfig';
import TopBanner from '../Other/TopBanner/TopBanner';
import img from '../../Asests/Images/limited_support_banner.png';
import BFCM2024Topbar from '../../Asests/pricing-images/BFCM_top_banner_new.png';
import BFCM2024Mobile from '../../Asests/pricing-images/bfcm-mobile-img.png';
import NewFaq from './Faq/components/NewFaq';
import KnowledgeBase from './KnowledgeBase/KnowledgeBase';
import BuyShipping from './BuyShipment/components/BuyShipping';
import NewAllSales from './NewAllSales/NewAllSales';
import ViewOrders from './NewAllSales/Components/OrderView/ViewOrders';
import Bulkedit from './Bulkedit/Bulkedit';
// import LocalDelivery from './Local Delivery/LocalDelivery';
// import LocalDeliveryProductEdit from './Local Delivery/Components/LocalDeliveryProductEdit/LocalDeliveryProductEdit';
import Unsubscribe from './Config/Component/Notifications/Unsubscribe';
import PricingDetail from './Pricing/PricingDetail/PricingDetail';
import OrderLimit from './Pricing/OrderLimitModal/OrderLimit';
import ProductLinkingsNew from './ProductLinkingsNew/components/ProductLinkingsNew';
import ListingGrid from './Listing Grid/ListingGrid';
import Overview from './Overview/Overview';
import NewProductImport from './NewProductImport/NewProductImport';
import OfferPrice from './Pricing/OfferPrice';
import StaffUserManagement from './StaffUserManagement/StaffUserManagement';
import Bdapanel from './Bdapanel/Bdapanel';
import VariantGrid from './Listing Grid/Components/VariantGrid/VariantGrid';
import { io, Socket } from 'socket.io-client';
import { DefaultEventsMap } from 'socket.io/dist/typed-events';
import { primaryAction } from '@shopify/app-bridge/actions/Toast';
import { message } from 'antd';
import FestiveModal from './Pricing/Componant/FestiveModal';
import { useMediaQuery } from '../Utilities/useMediaQuery';
import limited_support_banner from '../../Asests/Images/limited_support_banner.png';
import bannerFframe from '../../Asests/Images/banner-frame.png';
import NewPricingBanner2025 from '../../Asests/Images/newPricingBannerWithoutText.png';
import christmasMobileTopBar from '../../Asests/pricing-images/amz-christmas-top-bar-mobile.jpg';
import BFCM_img from '../../Asests/Images/BFCM-banner-strip.jpg';
import BFCM_img720 from '../../Asests/Images/BFCM - banner strip copy - size- 720 b.jpg';
import BFCM_img420 from '../../Asests/Images/BFCM - banner strip copy - size-400 b.jpg';

import { environment } from '../../environments/environment';
let socket: Socket<DefaultEventsMap, DefaultEventsMap>;

import * as Sentry from "@sentry/react";
import { AlertTriangleIcon } from '../../Asests/svgIcon/icon';
import { OrderLimitReachedRecommended } from './NewPricingFeb2025/Components/OrderLimitModal';
import NewArchievedorderPage from './NewAllSales/Components/OrderView/ArchievedOrderDetailPage/NewArchievedorderPage';
import NewAllSalesWithArchieved from './NewAllSales/NewAllSalesWithArchieved';

// Create a function to control sentry status( enable or disable) from cloud
const isEnableSentry = (USER_ID: string = '') => {
    if (process.env.REACT_APP_SENTRY !== '1') {
        return false;
    }
    const users = process.env.REACT_APP_SENTRY_USER_ENABLE?.split(',') || [];
    if (users.length === 0) {
        return true;
    }
    return users.includes(USER_ID);
};

export interface PanelProps extends DIProps {
    isUserExistsInMultiData?: any;
    name?: string;
    syncNecessaryInfo: ((message?: any) => void) | (() => void);
    syncConnectorInfo: (
        props: any,
        shop_url?: string | null,
        updateCurrentShop?: boolean,
        updateStepStatus?: React.Dispatch<React.SetStateAction<string>>
    ) => void;
    syncProfileInfo: () => void;
    loginStatus: () => void;
    syncServices: () => void;
    Menu?: MenuObj[]
    addAiEnabledOrNot?: (props: any) => void;
    saveCurrentPlanData?: (props: any) => void,

}
interface PanelHeadersProps extends PanelProps {
    disable_headers?: boolean;
    show_only_lng_switcher?: boolean
}

function Panel(props: PanelProps): JSX.Element {
    const navigate = useNavigate();
    const [firstRenderForSentry, setFirstRenderForSentry] = useState<boolean>(true);
    const [languageCall, setLanguageCall] = useState<boolean>(true);
    const { i18n, t } = useTranslation();
    const [topBanner, setTopBanner] = useState<any>({});
    const [byPassData, setByPassData] = useState<any>({
        code: "",
        message: ""
    });
    const { Navs } = Menu()
    const [firstRender, setFirstRender] = useState<boolean>(true);
    const isMobileView = useMediaQuery('(max-width: 576px)');
    const [hasBeenCalled, setHasBeenCalled] = useState(false);
    const [planStatus, updatePlanStatus] = useState('_WAITING_'); // _WAITING_ | _PENDING_ | _IMPORT_ | _DONE_
    const [orderLimitModal, setOrderLimitModal] = useState<boolean>(false);
    const [planDetails, setPlanDetails] = useState<any>(Object.keys(JSON.parse(props.di.globalState.get('isPlanExpired', true) ?? '{}')).length > 0 ? JSON.parse(props.di.globalState.get('isPlanExpired', true) ?? '{}') : '{}');
    const [showSettlementInfo, setShowSettlementInfo] = useState<boolean>(false);
    const [settlementData, setSettlementData] = useState<any>({});
    const [modal, setModal] = useState<any>({
        isOpen: false,
        description: `${'\n'} ${t("Error in refresh token.")} ${'\n'}`,
        title: t('Refresh Token'),
        primaryAction: false
    });
    const [StoreCloseModal, setStoreCloseModal] = useState(false)
    const dispatcher: any = useContext(StoreDispatcher);
    const { LOGIN_STATUS = { status: 'LOGIN' } } = props.redux;
    let stepStatus = props.redux.step_status ?? '_INPROGRESS_';
    const location = useLocation();
    const [BFCMModal, setBFCMModal] = useState<any>({})
    const [feedStatus, setfeedStatus] = useState<any>({})
    const [refreshToken, setRefreshToken] = useState(false);

    const PROD_IS = process.env.REACT_APP_PROD === '1';


    useEffect(() => {
        const shop = props.di.globalState.get(`shop`);
        (!(isAdminLoggedIn()
            // || process.env.REACT_APP_PROD === '0'
        ))
            && aAppdef('changeTarget', changeTarget); //setting route to loading in case of admin and local logging
        dispatcher({
            type: 'onBoarding',
            state: {
                step_status: props.di.globalState.get('onboarding_completed') ?? '_INPROGRESS_',
            },
        });
        dispatcher({
            type: 'user_id',
            state: {
                user_id: props.di.globalState.get('user_id') ?? props.match.uId,
                shop: shop,
            },
        });
        if (props.match.uId !== 'loading') {
            process.env.REACT_APP_PROD === '1' && !isAdminLoggedIn() ? !props.di.globalState.get(`shop`) && !props.redux?.user_id && con()
                :
                con();
            setTimeout(() => {
                if (props.di.globalState.get('isSettlementGenerated', true)) {
                    setShowSettlementInfo(true);
                    setSettlementData(JSON.parse(props.di.globalState.get('isSettlementGenerated', true) ?? '{}'));
                } else {
                    setShowSettlementInfo(false);
                    setSettlementData({});
                }

                if (props.location.pathname !== '/panel/user/home' || props.location.pathname !== '/panel/user/dashboard') {
                    if (Object.keys(JSON.parse(props.di.globalState.get('isPlanExpired', true) ?? '{}')).length > 0) {
                        setPlanDetails(JSON.parse(props.di.globalState.get('isPlanExpired', true) ?? '{}'));
                        if (props.location.pathname === '/panel/user/home/pricing' || props.location.pathname === '/panel/user/dashboard/pricing') {
                            setOrderLimitModal(false);
                        } else setOrderLimitModal(true);
                    }
                }
            }, 3000);
        }
    }, [props.di.globalState.get(`shop`), props?.redux?.current_plan?._id]);

    // useEffect(() => {
    //     props.di.globalState.get(`target_id`) && props.di.POST('connector/config/getConfig', {
    //         "group_code": ["language"]
    //     }).then((response: any) => {
    //         if (response.success) {
    //             const selectedLanguage = response?.data?.[0]?.value?.selectedLanguage;
    //             i18n.changeLanguage(selectedLanguage);
    //             props?.di?.globalState?.set('language', selectedLanguage ?? 'en');
    //         } else {
    //             props.error(t(response.message));
    //         }
    //     });
    // }, [props.di.globalState.get(`target_id`)]);

    useEffect(() => {
        if (!props.di.globalState.get('isSettlementGenerated', true)) {
            setShowSettlementInfo(false);
        }
    }, [props.di.globalState.get('isSettlementGenerated', true)]);




    const checkStoreStatus = () => {
        props.di.GET("shopifyhome/request/checkStoreStatus").then((response) => {
            if (response?.success) {
                if (response?.message) {
                    props.success(response.message)
                }
                setStoreCloseModal(false)

            } else {
                if (response?.message) {
                    props.error(response?.message)
                }
            }
        })

    }




    // useEffect(() => {
    //     //Multi language modal
    //     if (props?.redux?.language) {
    //         //Bfcm modal
    //         props.di.POST('connector/config/getConfig', {
    //             "group_code": ["bfcm_2024_modal", "feedStatus"]
    //         }).then((response: any) => {
    //             if (response.success) {

    //                 const bfcmData = response?.data?.find((item: any) => item?.group_code === "bfcm_2024_modal");
    //                 const feedStatus = response?.data?.find((item: any) => item?.group_code === "feedStatus");
    //                 setfeedStatus(feedStatus)
    //                 setBFCMModal(bfcmData);
    //             } else {
    //                 props.error(t(response.message));
    //             }
    //         });
    //     }
    //     else {
    //         try {
    //             props.di.POST('connector/config/getConfig', {
    //                 "group_code": ["language", "bfcm_2024_modal", "feedStatus"]
    //             }).then((response: any) => {
    //                 if (response?.success) {

    //                     const bfcmData = response?.data?.find((item: any) => item?.group_code === "bfcm_2024_modal");
    //                     setBFCMModal(bfcmData);
    //                     const feedStatus = response?.data?.find((item: any) => item?.group_code === "feedStatus");
    //                     setfeedStatus(feedStatus)

    //                     if (hasSelectedLanguage(response, "language", "selectedLanguage")) {
    //                         dispatcher({
    //                             type: 'update_language',
    //                             state: {
    //                                 language: response?.data?.[0]?.value?.selectedLanguage ?? 'en',
    //                             },
    //                         });
    //                         props?.di?.globalState?.set('language', response?.data?.[0]?.value?.selectedLanguage ?? 'en');
    //                         i18n.changeLanguage(response?.data?.[0]?.value?.selectedLanguage ?? 'en');
    //                     }
    //                     // else { no need to activate language modal on every page of the app
    //                     //     setModalActive(true);
    //                     // }
    //                 } else {
    //                     props.error(t(response.message));
    //                 }
    //             });
    //         }
    //         catch (error) {
    //             console.error("Failed to fetch language config:", error);
    //             props.error(t("An error occurred while fetching language settings."));
    //         }
    //     }
    // }, [])

    const fetchLanguageConfig = async () => {
        const url = `${environment.API_ENDPOINT}connector/config/getConfig`;
        const requestHeaders = new Headers();
        const auth: any = props.di.globalState.getBearerToken();

        // Set headers
        requestHeaders.set('Authorization', auth);
        requestHeaders.set('appCode', "eyJzaG9waWZ5IjoiYW1hem9uX3NhbGVzX2NoYW5uZWwiLCJhbWF6b24iOiJhbWF6b24ifQ==");
        requestHeaders.set('appTag', "amazon_sales_channel");
        requestHeaders.set('Content-Security-Policy', "frame-ancestors https://admin.shopify.com");
        requestHeaders.set('Ced-Source-Id', props.di.globalState.get('source_id') ?? '');
        requestHeaders.set('Ced-Source-Name', "shopify");
        // requestHeaders.set('ced-target-name', "amazon");
        requestHeaders.set('Content-Type', 'application/json');

        const requestBody = JSON.stringify({ group_code: ["language"] });

        try {
            const response = await fetch(url, {
                headers: requestHeaders,
                method: 'POST',
                body: requestBody,
            });
            const data = await response.json();

            if (data?.success) {
                return data;
            } else {
                throw new Error(data?.message || "Failed to fetch language settings.");
            }
        } catch (error) {
            console.error("Language API Error:", error);
            throw new Error("An error occurred while fetching language settings.");
        }
    };

    useEffect(() => {
        const initializeConfigs = async () => {
            try {
                if (props?.redux?.language) {
                    // Language already set, fetch other configurations
                    const response = await props.di.POST('connector/config/getConfig', {
                        group_code: ["bfcm_2024_modal", "feedStatus"],
                    });

                    if (response?.success) {
                        const bfcmData = response?.data?.find((item: any) => item?.group_code === "bfcm_2024_modal");
                        const feedStatus = response?.data?.find((item: any) => item?.group_code === "feedStatus");
                        setBFCMModal(bfcmData);
                        setfeedStatus(feedStatus);
                    } else {
                        props.error(t(response.message));
                    }
                } else {
                    // Fetch "language" using custom API function
                    const languageResponse = await fetchLanguageConfig();
                    const selectedLanguage = languageResponse?.data?.[0]?.value?.selectedLanguage || "en";

                    if (hasSelectedLanguage(languageResponse, "language", "selectedLanguage")) {
                        dispatcher({
                            type: 'update_language',
                            state: { language: selectedLanguage },
                        });
                        props?.di?.globalState?.set('language', selectedLanguage);
                        i18n.changeLanguage(selectedLanguage);
                    }

                    // Fetch other configurations separately
                    setTimeout(async () => {
                        const response = await props.di.POST('connector/config/getConfig', {
                            group_code: ["bfcm_2024_modal", "feedStatus"],
                        });

                        if (response?.success) {
                            const bfcmData = response?.data?.find((item: any) => item?.group_code === "bfcm_2024_modal");
                            const feedStatus = response?.data?.find((item: any) => item?.group_code === "feedStatus");
                            setBFCMModal(bfcmData);
                            setfeedStatus(feedStatus);
                        } else {
                            props.error(t(response.message));
                        }
                    }, 1000)
                }
            } catch (error) {
                console.error("Error initializing configurations:", error);
                props.error(t("An error occurred while fetching configurations."));
            }
        };

        initializeConfigs();
    }, []);

    // zoho crm script
    useEffect(() => {
        if (props?.redux?.current?.source && props.redux.current?.source?.store_closed_at) {
            setStoreCloseModal(true);
        }
        const win: any = window;
        // Create a script element
        if (props.di.globalState.get(`source_id`) && props.redux.current?.source
            // && props?.redux?.current_plan
            // && props.di.user_id != "641adf51fde0c9a1e0054481"
            // && process.env.REACT_APP_PROD == '1' && !isAdminLoggedIn()
        ) {
            if (props?.redux?.current_plan
                && props.di.user_id != "641adf51fde0c9a1e0054481"
                && process.env.REACT_APP_PROD == '1' && !isAdminLoggedIn()) {
                const zohoObj = win.$zoho || {};
                if (win.$zoho && win.$zoho.salesiq) {
                    // The script is loaded, apply your conditions here
                    let { planStatus, planTitle } = getPlanStatus(props?.redux?.current_plan);
                    zohoObj.salesiq.ready = function () {
                        // zohoObj.salesiq.customfield.add({
                        //     'Store URL': props?.redux?.current?.source?.domain ?? props?.redux?.current?.source?.username ?? '',
                        //     'Payment Status': planStatus ?? 'Trial',
                        // });
                        zohoObj.salesiq.visitor.info({
                            'Store URL': props?.redux?.current?.source?.username ?? props?.redux?.current?.source?.domain ?? '',
                            'Payment Status': planStatus ?? 'Trial',
                            'App Name': 'Cedcommerce Amazon Channel',
                            'FrameWork': 'Shopify'
                        });
                        zohoObj.salesiq.visitor.name(props?.redux?.current?.source?.shop_owner ?? 'N/A');
                        zohoObj.salesiq.visitor.email(props?.redux?.current?.source?.customer_email ?? 'N/A');
                        zohoObj.salesiq.visitor.contactnumber(props?.redux?.current?.source?.phone ?? 'N/A');
                    };
                    zohoObj.salesiq.onVisitorTyping = function () {
                        window.postMessage({ type: "user_typing" }, "*");
                    };
                }
                else {
                    // Set the attributes for the script
                    const script = document.createElement('script');
                    script.type = 'text/javascript';
                    script.id = 'zsiqscript';
                    script.defer = true;
                    script.src = 'https://salesiq.zohopublic.in/widget';
                    // Append the script to the document body
                    document.body.appendChild(script);
                    // Set the Zoho SalesIQ widget code dynamically
                    win.$zoho = win.$zoho || {};
                    win.$zoho.salesiq = win.$zoho.salesiq || {
                        widgetcode: "siqa8c5761519650fe047076203095c17a98d7328e7afd77313fcda6c78dfb88931",
                        values: {},
                        ready: function () { }
                    };
                    // Execute the ready function
                    if (typeof win.$zoho.salesiq.ready === 'function') {
                        win.$zoho.salesiq.ready();
                    }
                }
            }
        }

    }, [props.di.globalState.get(`source_id`), props.redux.current?.source, props?.redux?.current_plan]);

    const checkDisconnectedTarget = () => {
        let isDisconnected: boolean = false;
        props?.redux?.current?.source?.targets?.map((target: any) => {
            if (target.shop_id == props.di.globalState.get("target_id")) {
                if (target.disconnected) isDisconnected = true
            }
        });
        return isDisconnected;
    }

    // By pass app when admin login is true
    useEffect(() => {
        if (
            isAdminLoggedIn()
            // || process.env.REACT_APP_PROD == "0"
        ) {
            let shop: any = props.di.globalState.get("shop")
            if (props.di.globalState.get("target_id")) {
                if (props?.redux?.current?.source?.apps?.[0]?.app_status == "uninstall") { //p1
                    byPassData['code'] = "uninstalled_app";
                    byPassData['message'] = <Text as='p'>
                        Attention: You are logged in as BDA. The user <b>{shop}</b> has <b>uninstalled</b> the app. Please refrain from performing any actions such as uploading, syncing, or similar tasks.
                    </Text>
                }
                else if (!props.redux.sync_activated && settlementData && Object.keys(settlementData).length > 0) {
                    byPassData['code'] = "plan_exhaust";
                    byPassData['message'] = <Text as='p'>
                        Attention! You logged in as BDA. <b>Plan</b> has been <b>exhausted</b> for this user {<b>{shop}</b>}. Please don't perform any actions such as uploading, syncing, etc.
                    </Text>
                }
                else if (!("current_plan" in props.redux && "sync_activated" in props.redux)) {

                    byPassData['code'] = "new_user_with_no_plan";
                    byPassData['message'] = <Text as='p'>
                        Attention: You are logged in as BDA. The user <b>{shop}</b> has <b>no active plan</b>. Please don't perform any actions such as uploading, syncing, etc.
                    </Text>
                }
                else if (checkDisconnectedTarget()) { //yeh last me rakhna hai
                    byPassData['code'] = "disconnected_target";
                    byPassData['message'] = <Text as='p'>
                        Attention: You are logged in as BDA. The user <b>{shop}</b> has <b>disconnected</b> this <b>target</b>. Please refrain from performing any actions such as uploading, syncing, or similar tasks.
                    </Text>
                }
                else {
                    byPassData['code'] = "";
                    byPassData['message'] = ""
                    setByPassData(byPassData)
                }
            }
            props.di.globalState.set("byPassAdminCode", byPassData['code'])
            setByPassData(byPassData)
        }
    }, [props.di.globalState.get(`source_id`), props.redux.current?.source, props?.redux?.current_plan, props.di.globalState.get(`target_id`), settlementData])



    useEffect(() => {
        if (props.match.uId !== 'loading') {
            con();
            props.saveCurrentPlanData && props.saveCurrentPlanData(props);
        }
    }, [props.di.globalState.get(`target_id`)]);


    function getConnectedSources(socket: any) {
        let id = props.di.globalState.get('remote_shop_id')
        socket.disconnect()
        if (!id || id === '') return;
        props.di.POST("amazon/request/getConnectedSource", { "remote_shop_id": id }).then((data) => {
            if (data?.success && Array.isArray(data?.data))
                props.di.globalState.set('connected_sources', JSON.stringify(data.data))
            else
                props.error(t(data?.message) ?? t("Couldn't find connected sources"))
        })
    }

    function connectAmazon(socket: any = '') {
        let state = { "app_tag": props.di.environment.appTag, "user_id": props.di.user_id, "source": "shopify", "source_shop_id": props?.redux?.current?.source?.['_id'] ?? '', "redirect_return_type": "message" }
        let url = `${props.di.environment.API_ENDPOINT}connector/get/installationForm?code=${'amazon'}&region=${props?.redux?.current?.target?.warehouses?.[0]?.region}&version=new&sandbox=1&marketplace_id=${props?.redux?.current?.target?.warehouses?.[0]?.marketplace_id}&state=${JSON.stringify(state)}&bearer=${props.di.globalState.getBearerToken()}`;
        let test = window.open(url + '&redirect_return_type=message', 'popUpWindow', 'height=500,width=800,left=100,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes');

        if (test) {
            const int = setInterval(() => {
                if (test?.closed) {
                    props?.di?.globalState?.removeLocalStorage('refreshToken')
                    getConnectedSources(socket)
                    const shop = props.di.globalState.get(`shop`);
                    props.syncConnectorInfo(props, shop, false);
                    props.syncNecessaryInfo({ connectAmazon: true, onboardingProps: props, source_shop_id: props?.redux?.current?.source?.['_id'] ?? '', target_shop_id: props?.redux?.current?.target?.['_id'] ?? "" });
                    clearInterval(int);
                }
            }, 1000);
        }
        else {
            url = url + '&redirect_return_type=app';
        }
        // if no
        // then open modal and add anhor tag <a/>
    }


    const tokenExpirationReAuth = () => {
        props.di.globalState.removeLocalStorage('remote_shop_id')
        socket = io('https://amazon.websocket.cedcommerce.com/', { path: '/onboarding.live', transports: ["websocket", "polling"] });;
        socket.on('connect', () => {
            socket.emit("set_room", props.di.user_id + props?.redux?.current?.source?.['_id']);
            socket.on('getRemoteShopID', (data: string) => {
                props.di.globalState.set('remote_shop_id', data, true)
            });
        })
        socket.on('disconnect', () => { })
        connectAmazon(socket);
        // props.di.globalState.set('account_checklist', JSON.stringify(states?.['accont_connection_list']), true);
    }







    useEffect(() => {
        let already_calledApi = props?.di?.globalState?.get('refreshToken') ?? '';
        let OnPages = ['home', 'failed-order/overview', 'feeds', 'product', 'productlinkings', 'dashboard']
        if (props?.redux?.current?.source?._id && props?.redux?.current?.target?._id && already_calledApi !== props?.match?.['*'] && OnPages.includes(props?.match?.['*'])) {
            setRefreshToken(true);
        } else {
            props?.di?.globalState?.removeLocalStorage('refreshToken')
        }
    }, [props?.redux?.current?.source?._id, props?.redux?.current?.target?._id, props?.match?.['*']])

    // useEffect(() => {
    //     if (props?.redux?.current?.target?.reauth_required) {
    //         setModal({
    //             isOpen: true,
    //             description: t(`${t('To ensure you receive important notifications from CedCommerce in your Amazon Seller Central, please re-authenticate your account. Need help? Contact Support.')} ${t("\n")}`),
    //             title: t('Reauthenticate Your Account'),
    //             footer: <Link
    //                 target='_blank'
    //                 url="https://calendly.com/cedcommerce-awe-sales/sales">
    //                 {t("Need help? Contact Support.")}
    //             </Link>,
    //             primaryAction: {
    //                 content: "Reauthenticate Now",
    //                 onAction: tokenExpirationReAuth
    //             }
    //         })
    //     }
    // }, [props?.redux?.current?.target])


    function getFirstAndLastName(user: any) {
        let shopifyData: any = user?.shops?.filter((singleObj: any) => singleObj?.marketplace == 'shopify');

        let name: string = shopifyData?.[0]?.shop_owner ?? '';
        let firstName: string = '';
        let lastName: string = '';
        if (name) {
            if (name.indexOf(' ') != -1) {
                firstName = name.slice(0, name.indexOf(' '));
                lastName = name.slice(name.indexOf(' ') + 1);
            } else {
                firstName = name;
            }
        }
        return { firstName, lastName };
    }

    const getPlanStatus = (user: any) => {
        let planStatus: string = 'Trial';
        let planTitle: string = 'Trial';

        if (user?.plan_details?.custom_price == 0) {
            planStatus = 'Free';
            planTitle = 'Free';
        } else if (user?.plan_details?.custom_price > 0) {
            planStatus = 'Paid';
            planTitle = user?.plan_details?.title;
        }
        return { planStatus, planTitle };
    };

    const getExternalId = (user: any, sourceData: any) => {
        let email = user?.email ?? sourceData?.email ?? '';
        return props?.di?.user_id + '_' + email;
    };

    const getPurchasedStatus = (status: string, title: string) => {
        if (status == "Paid") return "Purchased";
        else return "Not Purchased";
    }

    useEffect(() => {
        if (props.match.uId !== 'loading') {
            props.di.globalState.get(`shop`) && con();
            props.di.globalState.get(`shop`) && props.saveCurrentPlanData && props.saveCurrentPlanData(props);
        }

        // Check if Sentry is already initialized
        const sentryInitialized = props?.di?.globalState?.get('sentryInitialized');

        // sentry script should be initialised only one time
        if (
            firstRenderForSentry &&
            !sentryInitialized && // Ensure Sentry is not reinitialized
            !isAdminLoggedIn() &&
            props?.di?.user_id &&
            isEnableSentry(props.di.user_id)
        ) {
            setFirstRenderForSentry(false);
            props?.di?.globalState?.set('sentryInitialized', 'true'); // Mark Sentry as initialized
            Sentry.init({
                dsn: process.env.REACT_APP_SENTRY_DSN,
                environment: process.env.REACT_APP_SENTRY_MODE,
                integrations: [
                    Sentry.browserTracingIntegration(),
                    Sentry.replayIntegration({
                        maskAllText: false,
                        blockAllMedia: false,
                    }),
                ],
                // Performance Monitoring
                tracesSampleRate: 1.0, //  Capture 100% of the transactions
                // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
                tracePropagationTargets: [
                    'localhost'
                ],
                // Session Replay
                replaysSessionSampleRate: 0.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
                replaysOnErrorSampleRate: process.env.REACT_APP_SENTRY_MODE === 'production' ? 1.0 : 0.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
            });
        }

    }, [props.di.globalState.get(`target_id`)]);

    useEffect(() => {
        if (props.di.globalState.get(`topBanner`)) {
            setTopBanner(JSON.parse(props.di.globalState.get(`topBanner`) ?? ''))
        }
    }, [props.di.globalState.get(`topBanner`)]);

    const checkPlanExpiration = () => {
        if (Object.keys(JSON.parse(props.di.globalState.get('isPlanExpired', true) ?? '{}')).length > 0) {
            setPlanDetails(JSON.parse(props.di.globalState.get('isPlanExpired', true) ?? '{}'));
            if (props.location.pathname === '/panel/user/home/pricing' || props.location.pathname === '/panel/user/dashboard/pricing') {
                setOrderLimitModal(false);
            } else setOrderLimitModal(true);
        } else setOrderLimitModal(false);
        if (props.di.globalState.get('isSettlementGenerated', true)) {
            setShowSettlementInfo(true);
            setSettlementData(JSON.parse(props.di.globalState.get('isSettlementGenerated', true) ?? '{}'));
        } else {
            setSettlementData({});
            setShowSettlementInfo(false);
        }
    };

    if (LOGIN_STATUS.status === 'LOGOUT') {
        return <ShowLogOutScreen {...props} {...LOGIN_STATUS} />;
    }

    if ((!PROD_IS || isAdminLoggedIn()) && !props.di.globalState.get(`shop`)) {
        return renderSourceSelectionAction(props, dispatcher, t);
    }

    if (PROD_IS && !isAdminLoggedIn()) {
        if (checkForAutoLogin(props)) {
            redirectToApp(props);
            return <RenderSkeleton {...props} />;
        } else if (props.match.uId != 'loading' && !isShopifyEmbedded()) {
            if (!isMobile()) {
                openAppInEmbedded(props);
                return <RenderSkeleton {...props} />;
            }
        }
    }

    if (props.match.uId === 'loading') {
        RedirectToHome(props);
        return <RenderSkeleton {...props} />;
    }

    function con(): void {
        const shop = props.di.globalState.get(`shop`);
        props.syncConnectorInfo(props, shop); //Don't add AWAIT DURING PRODUCTION

        // if (props.redux.current_plan?.plan_details?.code == 'trial' && !props.redux.sync_activated) {
        //     props.di.globalState.set('is_plan_active', 'open_plan')
        //     updatePlanStatus('_PENDING_');
        // }
        // else {

        if (props.di.globalState.get(`is_plan_active`)) {

            if (props.di.globalState.get(`is_plan_active`) === 'open_plan') {

                updatePlanStatus('_PENDING_');
            } else {
                updatePlanStatus('_DONE_');

            }
        } else {
            const res = shop && props.di.GET('plan/plan/isPlanActive')
                .then((e: any) => {
                    if (e['success']) {
                        // props.di.globalState.set(`is_plan_active`, 'true');
                        updatePlanStatus('_DONE_');
                    } else {
                        updatePlanStatus('_PENDING_');
                    }
                });
        }

        // }
        setHasBeenCalled(true);
    }

    let BodyRender = null;
    if (
        (stepStatus != '_COMPLETED_' && stepStatus != '_NEWACCOUNT_') ||
        props?.redux?.account?.target?.['amazon'].length == 0
    ) {
        BodyRender = (
            <Routes>
                <Route path="loading" element={<>{t("loading")}</>}>
                    <Route
                        path="*"
                        element={
                            <Card padding="0" roundedAbove="sm">
                                {t("NO Page Found 2")}
                            </Card>
                        }
                    />
                </Route>
                <Route
                    path="*"
                    element={
                        <Page
                            primaryAction={
                                props?.redux?.account?.target?.['amazon']
                                    .length > 1 && (
                                    <RenderHeadersAction {...props} />
                                )
                            }>
                            <Onboarding updatePlanStatus={updatePlanStatus} />
                        </Page>
                    }>
                    <Route
                        path="*"
                        element={
                            <Card padding="0">{t("NO Page Found 2")}</Card>
                        }
                    />
                </Route>
            </Routes>
        );
    } else if (planStatus === '_PENDING_' || (props.redux.current_plan?.plan_details?.code == 'trial' && !props.redux.sync_activated)) {
        // props.history('home/pricing')
        BodyRender = (
            <ScrollToTop>
                <NewPricingPlan
                    planIsActive={() => {
                        updatePlanStatus('_DONE_');
                    }}
                    importValidation={() => {
                        updatePlanStatus("_IMPORT_")
                    }}
                    checkPlanExpiration={checkPlanExpiration}
                />

                {showSettlementInfo && (
                    <SettlementModal settlementData={settlementData} />
                )}
            </ScrollToTop>
        );
    }
    else if (planStatus === "_IMPORT_") {
        return <PricingDetail
            planIsActive={() => {
                updatePlanStatus('_DONE_');
            }}
            upgradePlan={() => {
                updatePlanStatus('_PENDING_')
            }}
        />
    }
    else if (planStatus === '_WAITING_') {
        return <RenderSkeleton {...props} />;
    } else {
        BodyRender = renderApp();
    }

    if (byPassData['message']) {
        BodyRender = renderApp();
    }

    return (
        <>
            {hasBeenCalled && props.redux?.loaded ? (
                BodyRender
            ) : (
                <RenderSkeleton {...props} />
            )}
        </>
    );

    function renderApp(): JSX.Element {
        const menuNav = showOnlyGrid(props.di.user_id, props) ? []
            :
            Object.values(Navs)
                .filter((e: any) => !e.hidden)
                .map((e: any) => {
                    return {
                        label: e['label'],
                        onClick: () => props.history('/panel/' + props.match.uId + '/' + e['path'])
                    };
                });
        let setting: any = {};

        Object.values(Navs).map((e: any) => {
            setting[e['path']] = e;
        });
        const title = getTitle({ ...props, Menu: Navs });
        const subtitle = getSubTitle({ ...props, Menu: Navs });
        const navigationMarkup = (
            <Navigation location="/product">
                <Navigation.Section items={menuNav} />
            </Navigation>
        );


        return (
            <Frame
                navigation={
                    PROD_IS && !isAdminLoggedIn() ? null : navigationMarkup
                }>
                {/* BFCM festive offers Banner/ Announcement */}
                {/* <TopBanner data={
                    [
                        // {
                        //     defaultbackground: Diwali,
                        //     backroundImageSource: [
                        //         {
                        //             img: Diwali,
                        //             width: 1200
                        //         },
                        //         {
                        //             img: Diwali720,
                        //             width: 620
                        //         }, {
                        //             img: Diwali420,
                        //             width: 0
                        //         }
                        //     ],
                        //     text:
                        //         <Text as='p'>
                        //             Happy Diwali! Light up the festival with joy! Limited support available (12th & 13th Nov 2023)- {' '}
                        //             <Link monochrome onClick={() => props.history('support')}>Reach us</Link>
                        //             &nbsp;for any urgent assistance.
                        //         </Text>
                        // },
                        {
                            defaultbackground: BFCM_img,
                            backroundImageSource: [
                                {
                                    img: BFCM_img,
                                    width: 1200
                                },
                                {
                                    img: BFCM_img720,
                                    width: 620
                                }, {
                                    img: BFCM_img420,
                                    width: 0
                                }
                            ],
                            text:
                                <Text as='p'>
                                    App Maintenance Notice: Scheduled Maintenance on 3rd June 2025 from 12:30 PM to 1:30 PM IST.&nbsp;
                                    <Link monochrome target='_blank' url='https://support.cedcommerce.com/portal/en/newticket?departmentId=132692000000010772&layoutId=132692000092595993'>Contact Us</Link>
                                    &nbsp;for any query.
                                </Text>
                        },
                    ]
                }
                /> */}
                <TopBanner data={
                    [
                        {
                            defaultbackground: NewPricingBanner2025,
                            backroundImageSource: [
                                {
                                    img: NewPricingBanner2025,
                                    width: 1200
                                },
                                {
                                    img: NewPricingBanner2025,
                                    width: 620
                                }, {
                                    img: NewPricingBanner2025,
                                    width: 0
                                }
                            ],
                            action: () => navigate("home/pricing"),
                            text: (
                                <BlockStack align='center' inlineAlign='center' gap={"100"}>
                                    <Text as='p' fontWeight='bold' variant='headingLg'>{t("Updated Pricing, Better Value!")}</Text>
                                    <Text as='p' fontWeight='bold' variant='headingMd'>{t("Discover revised pricing plans designed to support your growing business needs.")}</Text>
                                </BlockStack>
                            ),
                            warning: false
                        },
                    ]
                }
                />

                {
                    (isAdminLoggedIn()
                        // || process.env.REACT_APP_PROD === "0"
                    )
                    && byPassData['message']
                    && <TopBanner data={
                        [
                            {
                                defaultbackground: img,
                                backroundImageSource: [
                                    {
                                        img: img,
                                        width: 1200
                                    },
                                    {
                                        img: img,
                                        width: 620
                                    }, {
                                        img: img,
                                        width: 0
                                    }
                                ],
                                text:
                                    byPassData['message'],
                                warning: true
                            },
                        ]
                    }
                    />}


                {
                    setting[props['match']['*']]?.['showPage'] ? (
                        <Page
                            fullWidth={setting[props['match']['*']]?.['fullscreen']}
                            title={title}
                            subtitle={subtitle}
                            backAction={
                                setting[props['match']['*']]?.['breadcrum'] && {
                                    content: '',
                                    onAction: () => {
                                        props.history(
                                            setting[props['match']['*']][
                                            'breadcrum'
                                            ]
                                        );
                                    },
                                }
                            }
                            primaryAction={
                                setting[props['match']['*']]?.[
                                    'showTargetSelect'
                                ] ? (
                                    <RenderHeadersAction {...props} show_only_lng_switcher={setting[props['match']['*']]?.['show_only_lng_switcher'] ?? false} />
                                ) : undefined
                            }>
                            {renderRoutes()}
                            <FooterHelp>
                                <InlineStack align="center" gap='100'>
                                    <div>
                                        <Icon
                                            source={CircleInformationMajor}
                                            tone="info"
                                        />
                                    </div>
                                    {t("Learn more about")}
                                    <Link
                                        target='_blank'
                                        url={"https://support.cedcommerce.com/portal/en/kb/articles/article-28-3-2025"}>
                                        {t("CedCommerce Amazon Channel")},
                                    </Link>
                                    <Link
                                        target={'_blank'}
                                        url="https://amazon-sales-channel-app-backend.cifapps.com/Cedcommerce_Privacy_Statement.pdf">
                                        {t("Terms & Conditions")}
                                    </Link>{' '}
                                    {t("and")}
                                    <Link
                                        target={'_blank'}
                                        url="https://amazon-sales-channel-app-backend.cifapps.com/Data_Privacy_Rights.pdf">
                                        {t("Data Privacy Rights.")}
                                    </Link>
                                    {t("Need Help?")}
                                    <Link
                                        target='_blank'
                                        url={`https://admin.shopify.com/apps${process.env.REACT_APP_SHOPIFY_APP_BASE}/panel/user/support`}
                                    // onClick={() =>
                                    //     props.history('support')
                                    // }
                                    >
                                        {t("Get Support")}
                                    </Link>
                                    or
                                    <Link
                                        target='_blank'
                                        url="https://calendly.com/cedcommerce-awe-sales/sales">
                                        {t("Book a Call")}
                                    </Link>
                                </InlineStack>
                            </FooterHelp>
                        </Page>
                    ) : (
                        renderRoutes()
                    )
                }

                {refreshToken && <Checkrefreshtoken tokenExpirationReAuth={tokenExpirationReAuth} t={t} {...props} feedStatus={feedStatus}></Checkrefreshtoken>}
                <Modal
                    open={modal?.isOpen}
                    primaryAction={modal?.primaryAction ? modal?.primaryAction : undefined}
                    secondaryActions={[
                        {
                            content: 'Close',
                            onAction: () => {
                                setModal((a: any) => ({ ...a, isOpen: false }))
                                props?.di?.globalState?.removeLocalStorage('refreshToken')
                            },
                        }
                    ]}
                    footer={modal?.footer ? modal?.footer : undefined}
                    onClose={() => {
                        props?.di?.globalState?.removeLocalStorage('refreshToken')
                        setModal((a: any) => ({ ...a, isOpen: false }))
                    }}
                    title={t(modal?.title)}
                >
                    <Modal.Section>
                        {modal?.description}
                        {/* <Banner tone="warning">{modal?.description || t('N/A')}</Banner> */}
                    </Modal.Section>
                </Modal>
                <Modal
                    open={StoreCloseModal}
                    primaryAction={{
                        content: t('Re-verify Store'),
                        onAction: () => checkStoreStatus()
                    }}
                    onClose={() => {
                        setStoreCloseModal(false)
                    }}
                    footer={true}
                    title={t("Account Issue Detected")}
                >
                    <Card >
                        <BlockStack gap={'300'}><Card background='bg-surface-warning'>
                            <InlineStack gap={'0'} align='start' blockAlign='start' wrap={false}>
                                <div style={{ margin: "0" }}>
                                    <Icon source={AlertTriangleIcon}></Icon>
                                </div>
                                <Text as='p' tone='critical' fontWeight='bold' >{t("Your Shopify store is either closed, currently inactive, or your payment method has been cancelled.")}</Text>
                            </InlineStack>
                            <div style={{ marginLeft: "22px" }}>
                                <Text tone='critical' as='p'>{t("As a result, your app's services have been impacted in the following ways:")}</Text>
                                <List type="bullet">
                                    <BlockStack gap="0">
                                        <List.Item>
                                            <Text tone='critical' as="h6">
                                                {t("Order Syncing Paused")}
                                            </Text>
                                        </List.Item>
                                    </BlockStack>
                                    <BlockStack gap="300">
                                        <BlockStack gap="0">
                                            <List.Item>
                                                <Text tone='critical' as="h6" >
                                                    {t('Product Updates Disabled')}:
                                                </Text>
                                            </List.Item>
                                        </BlockStack>
                                    </BlockStack>
                                    <BlockStack gap="300">
                                        <BlockStack gap="0">
                                            <List.Item>
                                                <Text tone='critical' as="h6" >
                                                    {t('Billing Suspended')}:
                                                </Text>
                                            </List.Item>
                                        </BlockStack>
                                    </BlockStack>
                                    <BlockStack gap="300">
                                        <BlockStack gap="0">
                                            <List.Item>
                                                <Text tone='critical' as="h6" >
                                                    {t('Other Services Impacted')}:
                                                </Text>
                                            </List.Item>
                                        </BlockStack>
                                    </BlockStack>
                                </List>

                            </div>

                        </Card>
                        </BlockStack>
                    </Card>

                </Modal>
                {showSettlementInfo && <SettlementModal settlementData={settlementData} />}

                {/* Order Limit reached Modal */}
                {orderLimitModal && <OrderLimitReachedRecommended {...props} orderLimitModal={orderLimitModal} setOrderLimitModal={setOrderLimitModal} planDetails={planDetails} />}
                {/* {orderLimitModal && <OrderLimit orderLimitModal={orderLimitModal} setOrderLimitModal={setOrderLimitModal} planDetails={planDetails} />} */}
                {/* {props?.redux?.user_id !== "6475faa1af905c944b0de4f3" && <FestiveModal BFCMModal={BFCMModal} {...props} />} */}
                <div style={{ zIndex: "1000000" }}></div>
            </Frame >
        );
    }




    function renderRoutes(): JSX.Element {
        return (
            <ScrollToTop>
                <Routes>
                    <Route
                        path="home/*"
                        element={
                            <Overview checkPlanExpiration={checkPlanExpiration} updatePlanStatus={updatePlanStatus} />
                        }
                    />
                    <Route
                        path="dashboard/*"
                        element={
                            <Overview checkPlanExpiration={checkPlanExpiration} updatePlanStatus={updatePlanStatus} />
                        }
                    />
                    <Route path="product" element={<ListingGrid />} />

                    <Route path="product/:c_id" element={<Editproduct />} />
                    <Route
                        path="product/:c_id/variant/:s_id"
                        element={<EditVariant />}
                    />
                    <Route path="product/new/:c_id" element={<EditproductNew />} />
                    <Route
                        path="product/new/:c_id/variant/:s_id"
                        element={<EditVariantNew />}
                    />
                    {/* <Route path="faq" element={<Faq />} /> */}
                    <Route path="faq" element={<NewFaq />} />
                    <Route path="feeds" element={<Feeds />} />
                    <Route path="loading" element={<>Loading</>} />
                    <Route path="product/bulkedit" element={<Bulkedit />} />
                    <Route path="home/pricing" element={<NewPricingPlan updatePlanStatus={updatePlanStatus} />} />
                    <Route path="dashboard/pricing" element={<NewPricingPlan updatePlanStatus={updatePlanStatus} />} />
                    <Route path='importValidation' element={<PricingDetail />} />
                    <Route path="newAccount" element={<NewAccount />} />
                    <Route path="home/*" element={<Activity />} />
                    <Route path="dashboard/*" element={<Activity />} />
                    <Route path="support" element={<Support />} />
                    <Route
                        path="productlinkings"
                        element={<ProductLinkingsNew />}
                    />
                    <Route
                        path="failed-order/:from"
                        element={<FailedOrder />}
                    />
                    <Route path="transfer-order" element={<TransferOrder />} />
                    <Route path="view-order/:o_id" element={<ViewOrder />} />
                    <Route
                        path="archived-order/:from"
                        element={<ArchivedOrder />}
                    />
                    <Route path="home/activity" element={<Activity />} />
                    <Route path="home/activity/import" element={<NewProductImport />} />
                    <Route path="home/pricing/offer" element={<NewPricingPlan updatePlanStatus={updatePlanStatus} />} />
                    <Route path="dashboard/activity" element={<Activity />} />
                    <Route path="dashboard/activity/import" element={<NewProductImport />} />
                    <Route path="dashboard/pricing/offer" element={<NewPricingPlan updatePlanStatus={updatePlanStatus} />} />
                    <Route path="cancelledOrders" element={<CancelledOrders />} />
                    <Route path="allSales" element={<NewAllSalesWithArchieved />} />
                    <Route path="viewOrder/:o_id" element={<ViewOrders />} />
                    <Route path="allOrders" element={<AllSales />} />
                    <Route path="allSales/newArchievedOrder" element={<NewArchievedorderPage />} />
                    <Route
                        path="unshippedOrders"
                        element={<UnshippedOrders />}
                    />
                    <Route
                        path="config/template/valueMapping/:t_id"
                        element={<ValueMapping />}
                    />
                    <Route path="config/template" element={<Settings />} />
                    <Route path="config/template/:t_id" element={<Settings />} />
                    <Route
                        path="default-template/:t_id"
                        element={<Settings />}
                    />
                    <Route path="config/*" element={<NewConfig />} />
                    <Route path="unsubscribe" element={<Unsubscribe />} />
                    {/* <Route path='localselling' element={<ViewAllStores />} /> */}
                    {/* <Route path='localdelivery' element={<LocalDelivery />} />
                    <Route path='localdelivery/localDeliveryEdit' element={<LocalDeliveryProductEdit />} /> */}
                    {/* <Route path='store/*' element={<CreateStoreForm />} /> */}
                    <Route path='allOrders/buyShipping/*' element={<BuyShipping />} />
                    <Route path='buyShipping/*' element={<BuyShipping />} />
                    {/* <Route path='localselling/order/:o_id' element={<Order />} /> */}
                    <Route path='knowledgeBase' element={<KnowledgeBase />} />
                    <Route path='knowledgeBase/:s_id/:kb_id' element={<KnowledgeBase />} />
                    <Route path='knowledgeBase/:s_id/:sb_id/:kb_id' element={<KnowledgeBase />} />
                    <Route path="staff/*" element={<StaffUserManagement />} />
                    <Route path="bda/*" element={<Bdapanel />} />
                    <Route path="product/variants" element={<VariantGrid />} />
                    <Route
                        path="*"
                        element={
                            <Card padding="0" roundedAbove="sm">
                                <BlockStack align="center" inlineAlign="center" gap="800">
                                    <Text as="p" fontWeight="bold">
                                        {t("Page Not Found")}
                                    </Text>
                                    <Button onClick={() => props.history(-1)}>
                                        {t("Go Back")}
                                    </Button>
                                </BlockStack>
                            </Card>
                        }
                    />
                </Routes>
            </ScrollToTop>
        );
    }
}

export const checkForOfferElegibility = (plan: any) => {
    if (((plan?.plan_details?.custom_price == 0 || plan?.plan_details?.title == "Free") && !plan?.custom_plan)) {
        return true;
    } else if (plan?.plan_details?.billed_type == "monthly" && !plan?.plan_details?.custom_plan && plan?.plan_details?.payment_type != 'one_time') {
        return true;
    } else {
        return false;
    }

}


const getHelpdocURL = (props: PanelProps) => {
    let menu: MenuObj | any = {};

    props?.Menu?.forEach((element: MenuObj) => {
        if (element.path === props.match['*'] && element.showPage && element?.footerUrl) {
            menu = element;
        }
    });
    return menu['footerUrl'];
}

function getTitle(props: PanelProps): string {
    let menu: MenuObj | any = {};

    props?.Menu?.forEach((element: MenuObj) => {
        if (element.path === props.match['*']) {
            menu = element;
        }
    });
    return menu['heading'];
}

function getSubTitle(props: PanelProps): string {
    let menu: MenuObj | any = {};

    props?.Menu?.forEach((element: MenuObj) => {
        if (element.path === props.match['*']) {
            menu = element;
        }
    });

    return menu['page_description'];
}

export const RenderHeadersAction = (props: PanelHeadersProps) => {
    const show_only_lng_switcher = props?.show_only_lng_switcher ?? false
    const { i18n, t } = useTranslation()
    const [activeToggle, setActive] = useState(false);
    const [activeToggleLanguage, setActiveLanguage] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState(props?.di?.globalState?.get('language') ?? 'en');
    const dispatcher = useContext(StoreDispatcher);

    // useEffect(() => {
    //     i18n.changeLanguage(selectedLanguage)
    // }, [])

    // const onLanguageChange = (lng: string) => {
    //     setSelectedLanguage(lng)
    //     i18n.changeLanguage(lng);
    //     setActiveLanguage(init => !init);
    //     changeLanguage(props, lng, dispatcher)
    // }
    // const languagesOptions = [
    //     {
    //         content: 'English',
    //         onAction: () => { onLanguageChange('en') },
    //         value: 'en'
    //     },
    //     {
    //         content: 'हिंदी',
    //         onAction: () => { onLanguageChange('hn') },
    //         value: 'hn'
    //     },
    //     {
    //         content: 'Deutsch',
    //         onAction: () => { onLanguageChange('gr') },
    //         value: 'gr'
    //     },
    //     {
    //         content: 'française',
    //         onAction: () => { onLanguageChange('fr') },
    //         value: 'fr'
    //     }
    // ]

    // const languageActivator = (
    //     <BlockStack>
    //         <Text as="p">{t("Language")}</Text>
    //         <Button
    //             onClick={() => { setActiveLanguage(a => !a) }}
    //             // disabled={props.disable_headers}
    //             disclosure>
    //             {languagesOptions?.find(lng => lng.value === selectedLanguage)?.content}
    //         </Button>
    //     </BlockStack>
    // );
    const toggleActive = useCallback(() => {
        setActive((active) => !active);

    }, []);

    let amazon: any = [];
    if (props.redux?.account?.target?.amazon) {
        amazon = props.redux?.account?.target?.amazon;
    }
    if (Object.keys(amazon).length > 0) {
        let options = [];
        let currentValue = props.redux?.current?.target?._id ?? '';

        options = amazon.map((e: any) => {
            let flagUrl = getCountryFlag(props, e['_id']);
            if (currentValue === e['_id']) {
                currentValue = (
                    <InlineStack align="center" blockAlign="center" gap="200" wrap={false}>
                        <div className="custom-flag">
                            <img src={flagUrl} />
                        </div>
                        <Text as="p" tone="subdued">
                            {e['sellerName'] ?? e['warehouses'][0]['seller_id']}
                        </Text>
                    </InlineStack>
                );
            }
            return {
                content: (
                    <InlineStack align="start" blockAlign="center" gap="200" wrap={false}>
                        <div className="custom-flag">
                            <img src={flagUrl} />
                        </div>
                        <Text as="p" tone="subdued">
                            {e['sellerName'] ?? e['warehouses'][0]['seller_id']}
                        </Text>
                    </InlineStack>
                ),
                onAction: () => {
                    changeTarget(props, e['_id'], dispatcher);
                    props.di.globalState.removeLocalStorage('onboarding_completed');
                    props.di.globalState.removeLocalStorage(`${props.redux?.user_id}_${props.redux?.current?.target?._id}_filters`);
                    props.di.globalState.removeLocalStorage('pagination');
                },
            };
        });
        options.push({
            content: (
                <Text as="span" tone="subdued">
                    {t("Add New Account")}
                </Text>
            ),
            icon: AddMajor,
            onAction: () => {
                props.di.globalState.set('onboarding_completed', '_ADDNEWACCOUNT_');
                props.history('/panel/' + props.di.user_id + '/newAccount');
            },
        });
        const activator = (
            <BlockStack gap="100">
                <Text as="p">{t("Seller Name")}</Text>
                <Button
                    onClick={toggleActive}
                    disabled={props.disable_headers}
                    disclosure>
                    {currentValue}
                </Button>
            </BlockStack>
        );
        return (
            <InlineStack wrap={false} gap='100'>
                {!show_only_lng_switcher && <Popover
                    active={activeToggle}
                    activator={activator}
                    autofocusTarget="first-node"
                    zIndexOverride={500}
                    onClose={toggleActive}>
                    <ActionList actionRole="menuitem" items={options} />
                </Popover>}
                {/* <Popover
                    active={activeToggleLanguage}
                    activator={languageActivator}
                    autofocusTarget="first-node"
                    zIndexOverride={500}
                    onClose={() => { setActiveLanguage(a => !a); }}>
                    <ActionList actionRole="menuitem" items={languagesOptions} />
                </Popover> */}
            </InlineStack>
        );
    }
    return <></>
    // return <Popover
    //     active={activeToggleLanguage}
    //     activator={languageActivator}
    //     autofocusTarget="first-node"
    //     zIndexOverride={500}
    //     onClose={() => { setActiveLanguage(a => !a); }}>
    //     <ActionList actionRole="menuitem" items={languagesOptions} />
    // </Popover>;
};

export function changeTarget(props: any, e: any, dispatcher: any) {
    let amazon: any = [];
    if (props.redux?.account?.target?.amazon) {
        amazon = props.redux?.account?.target?.amazon;
    }
    props.di.globalState.set('target_id', e);
    amazon.map((allAcc: any) => {
        if (allAcc['_id'] === e) {
            dispatcher({
                type: 'target_shop',
                state: {
                    target: allAcc,
                },
            });
        }
    });
    const shop = props.di.globalState.get(`shop`);
    syncConnectorInfo(props, shop);
    if (!(isAdminLoggedIn()
        // || process.env.REACT_APP_PROD == "0"
    )) {
        props.history('loading');
        props.history(-1);
    }
    dispatcher({
        type: 'onBoarding',
        state: {
            step_status: '_INPROGRESS_',
        },
    });

    (
        isAdminLoggedIn()
        || process.env.REACT_APP_PROD == "0"
    ) && window.location.reload()

}

export function changeLanguage(props: any, e: any, dispatcher: any) {
    props.di.globalState.set('language', e);
    props.history('loading');
    props.history(-1);
    dispatcher({
        type: 'update_language',
        state: {
            language: e,
        },
    });
}

function renderSourceSelectionAction(props: PanelProps, dispatcher: any, t: any): any {
    let shopify = [];
    if (Object.keys(props.redux?.account?.allsource?.shopify ?? []).length > 0) {
        shopify = props.redux?.account?.allsource?.shopify;
    }

    let len = Object.keys(shopify).length;

    if (showOnlyGrid(props.di.user_id, props) && len == 1) {
        let e = shopify[0]['myshopify_domain'];
        props.history('loading');
        props.history(-1);
        props.di.globalState.set('shop', e);
        dispatcher({
            type: 'user_id',
            state: {
                shop: e,
            },
        });
        return null;
    }

    if (len > 0) {
        const currentValue = props.redux?.current?.target?._id ?? '';
        shopify = shopify.map((e: any) => {
            return {
                label: e['myshopify_domain'] ?? e['name'],
                value: e['myshopify_domain'],
            };
        });

        return (
            <Page title={t("Select your Shopify Store")}>
                <Card roundedAbove="sm">
                    <Select
                        label={t("Seller Account")}
                        options={shopify}
                        value={currentValue}
                        placeholder={t('Select Your Store')}
                        onChange={(e: any) => {
                            syncConnectorInfo(props, e);
                            props.history('loading');
                            props.history(-1);
                            props.di.globalState.set('shop', e);
                            dispatcher({
                                type: 'user_id',
                                state: {
                                    shop: e,
                                },
                            });
                        }}
                    />
                </Card>
            </Page>
        );
    }
    return null;
}

const Checkrefreshtoken = (props: any) => {
    const { feedStatus, t, tokenExpirationReAuth } = props;
    const [checked, setChecked] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [modalData, setmodalData] = useState({
        open: false,
        title: "",
        description: <></>,
        primaryAction: {
            onAction: () => { },
            content: '',
            loading: false,
            disabled: !checked
        }
    })
    const reverifyToken = () => {
        setmodalData({
            ...modalData, primaryAction: {
                ...modalData?.primaryAction,
                loading: true
            }
        });
        let payload: any = {}
        if (feedStatus?.value?.accountStatus == 'inactive') {
            payload = {
                error_code: "InvalidInput"
            }
        } else {
            payload = {
                error_code: "Unauthorized"
            }

        }

        props.di.POST("amazon/request/validateAmazonAccountStatus", payload).then((response: any) => {
            setmodalData({
                ...modalData, primaryAction: {
                    ...modalData?.primaryAction,
                    loading: false
                }
            });
            if (response.success) {
                setmodalData({ ...modalData, open: false })
                props.success(response?.message ?? "your account is active")
            }
            else {
                setChecked(false)
                props.error(response?.message ?? "account status is undefined")
            }
        })

    }


    useEffect(() => {
        if (feedStatus?.value?.accountStatus == 'inactive') {
            setmodalData({
                open: true,
                title: t("Your Account is in Vacation Mode"),
                description: <BlockStack gap={'100'}>
                    <Box background='bg-surface-warning' padding={"200"} borderRadius='200'>
                        <InlineStack wrap={false} align='start' blockAlign='start' gap={'0'}>
                            <BlockStack align='start' gap={'100'}>
                                <InlineStack gap={'200'} align='start' blockAlign='start' wrap={false}>
                                    <div style={{ margin: "0" }}>
                                        <Icon source={AlertTriangleIcon}></Icon>
                                    </div>
                                    <BlockStack gap={"200"}>
                                        <Text as='p' tone='caution' variant='headingSm'>{t("This error indicates there may be an account issue. To troubleshoot, follow these steps:")}</Text>
                                        <BlockStack gap="025">
                                            <Text tone='caution' variant="headingXs" as="p" >
                                                1. {t("Log into Amazon Seller Central:")}
                                            </Text>
                                            <div className='pl-12'>
                                                <Text tone='caution' as="p" variant='bodySm' >
                                                    {t("Check for any account issues, including notifications under Performance or Account Health.")}
                                                </Text>
                                            </div>
                                        </BlockStack>
                                        <BlockStack gap="025">
                                            <Text tone='caution' variant="headingXs" as="p" >
                                                2. {t("Review Payment Information:")}
                                            </Text>
                                            <div className='pl-12'>
                                                <Text tone='caution' as="p" variant='bodySm' >
                                                    {t("Ensure payment methods are valid and up-to-date.")}
                                                </Text>
                                            </div>
                                        </BlockStack>
                                        <BlockStack gap="025">
                                            <Text tone='caution' variant="headingXs" as="p" >
                                                3. {t("Check for Notifications:")}
                                            </Text>
                                            <div className='pl-12'>
                                                <Text tone='caution' as="p" variant='bodySm' >
                                                    {t("Look for any important account alerts that could affect syncing.")}
                                                </Text>
                                            </div>
                                        </BlockStack>
                                        <BlockStack gap="025">
                                            <Text tone='caution' variant="headingXs" as="p" >
                                                4. {t("Contact Amazon Support:")}
                                            </Text>
                                            <div className='pl-12'>
                                                <Text tone='caution' as="p" variant='bodySm' >
                                                    {t("If issues persist, reach out to Amazon Seller Support for further assistance.")}
                                                </Text>
                                            </div>
                                        </BlockStack>
                                        <Box padding={"200"} background='bg-surface' borderRadius='200'>
                                            <InlineStack blockAlign='baseline' align='start' gap={'200'} wrap={false}>
                                                <Badge tone='warning'>Note</Badge>
                                                <Text as='p' variant='bodySm' fontWeight='medium' tone='caution'>{t("Payment method changes may take up to 48 hours to process, after which your account will be back to normal. Check status accordingly.")}</Text>
                                            </InlineStack>
                                        </Box>
                                    </BlockStack>
                                </InlineStack>
                            </BlockStack>
                        </InlineStack >
                    </Box >
                    <InlineStack>
                        <Checkbox
                            checked={checked}
                            onChange={handleChange}
                            label={
                                <Text as="strong" variant="headingSm">
                                    I have completed all the steps and I am ready to check my account status.
                                </Text>
                            }
                        />
                    </InlineStack>
                </BlockStack >,
                primaryAction: {
                    disabled: !checked,
                    content: "Re- verify",
                    loading: loading,
                    onAction: reverifyToken
                }
            })
        } else if (feedStatus?.value?.accountStatus == 'access_denied') {
            setmodalData({
                open: true,
                title: t("Access Restricted"),
                description:
                    <BlockStack gap={'300'}><Card background='bg-surface-warning'>
                        <InlineStack gap={'0'} align='start' blockAlign='start' wrap={false}>
                            <div style={{ margin: "0" }}>
                                <Icon source={AlertTriangleIcon}></Icon>
                            </div>
                            <Text as='p' tone='critical' >{t("This error indicates a possible issue with account authorization. To resolve:")}</Text>
                        </InlineStack>
                        <List type="number">
                            <BlockStack gap="0">
                                <List.Item>
                                    <Text tone='critical' variant="headingSm" as="h6">
                                        {t("Account Status:")}
                                    </Text>
                                </List.Item>
                                <Text tone='critical' as="p" fontWeight="regular" >
                                    {t("Check Performance > Account Health in Amazon Seller Central for any issues affecting your account.")}
                                </Text>
                            </BlockStack>
                            <BlockStack gap="300">
                                <BlockStack gap="0">
                                    <List.Item>
                                        <Text tone='critical' variant="headingSm" as="h6" >
                                            {t('Reauthorization')}:
                                        </Text>
                                    </List.Item>
                                    <Text tone='critical' as="p" fontWeight="regular" >
                                        {t("Click the Reauthorize button below to renew your account access.")}
                                    </Text>
                                </BlockStack>
                                <InlineStack align='start'>
                                    <Button onClick={() => { setmodalData({ ...modalData, open: false }); tokenExpirationReAuth() }} size='micro'>{t("Reauthorize")}</Button>
                                </InlineStack>
                            </BlockStack>
                        </List>
                    </Card>
                        <InlineStack>
                            <Checkbox
                                checked={checked}
                                onChange={handleChange}
                                label={
                                    <Text as="strong" variant="headingSm">
                                        {t("I have completed all the steps and I am ready to check my account status.")}
                                    </Text>
                                }
                            />
                        </InlineStack>
                    </BlockStack>,
                primaryAction: {
                    disabled: !checked,
                    content: "Re- verify",
                    loading: loading,
                    onAction: reverifyToken
                }
            })

        }
        else if (feedStatus?.value?.accountStatus == 'expired') {
            setmodalData({
                open: true,
                title: t("Reauthorization Required"),
                description:
                    <Card background='bg-surface-warning'>

                        <BlockStack gap={'200'}>
                            <InlineStack gap={'0'} align='start' blockAlign='start' wrap={false}>
                                <div style={{ margin: "0" }}>
                                    <Icon source={AlertTriangleIcon}></Icon>
                                </div>

                                <Text tone='critical' variant="headingSm" as="h6">{t("This error means the authorization token for our app has expired.")}</Text>
                            </InlineStack>
                            <div style={{ marginLeft: "inherit" }}>
                                <InlineStack align='start' gap={'100'}>
                                    <Text tone='critical' as="p" fontWeight="regular">
                                        {t("To fix it, reauthorize our app from your Amazon Seller Account.")}
                                    </Text>
                                    <Link url='https://bit.ly/3AfiOnK'>Click to view the Guide</Link>
                                </InlineStack>

                            </div>
                        </BlockStack>

                    </Card>
                ,
                primaryAction: {
                    disabled: false,
                    content: "Reauthorize",
                    loading: loading,
                    onAction: () => { setmodalData({ ...modalData, open: false }); tokenExpirationReAuth() }
                }
            })

        }

        // setData(response);
        props?.di?.globalState?.set('refreshToken', props?.match?.['*']);
        // props?.di?.globalState?.set('refreshToken_required', 'true'); //commenting since tour is not visible in overview page

    }, [feedStatus, checked]);

    const handleChange = useCallback(
        (newChecked: boolean) => {
            setChecked(newChecked); // Enable or disable the action
        },
        []
    );




    return (
        <Modal primaryAction={{ ...modalData?.primaryAction }
        }
            onClose={() => { setmodalData({ ...modalData, open: false }) }} title={modalData?.title} open={modalData.open} >
            <Modal.Section>
                {modalData.description}
            </Modal.Section>
        </Modal >

    );

}

export default DI(Panel, {
    func: {
        syncNecessaryInfo,
        syncConnectorInfo,
        syncProfileInfo,
        loginStatus,
        syncServices,
        saveCurrentPlanData
    }
});